//export const BASE_URL = 'http://localhost:8080/api';
export const BASE_URL = 'https://funnypet.site/api';

//export const BASE_MEDIA_URL = 'http://0.0.0.0:8000/media';
export const BASE_MEDIA_URL = 'https://funnypet.site/media';

export const DEFAULT_TOKEN_EXPIRE = 24 * 60 * 60 * 1000
export const KEY_USER_ID = 'user_id'
export const KEY_USER_NAME = 'user_name'
export const KEY_USER_TOKEN = 'user_token'

export const KEY_ADMIN_USER_NAME = 'admin_user_name'
export const KEY_ADMIN_USER_TOKEN = 'admin_user_token'
export const KEY_ADMIN_USER_ID = 'admin_user_id'

export const ADMIN_ROLE_ENUM = {
    ADMIN_ROLE_MANAGER: { key: 0, value: '管理员' },
    ADMIN_ROLE_OPERATOR: { key: 1, value: '操作员' },
}

export const USER_STATUE_ENUM = {
    USER_STATUS_NORMAL: { key: 0, value: '正常' },
    USER_STATUS_SEALED: { key: 1, value: '禁用' },
}

export const GENDER_ENUM = {
    GENDER_FEMALE: { key: 0, value: '男性' },
    GENDER_MALE: { key: 1, value: '女性' },
}

export const USER_ROLE_ENUM = {
    USER_ROLE_LOW: { key: 0, value: '普通' },
    USER_ROLE_VIP: { key: 1, value: 'VIP' },
    USER_ROLE_REVIEW: { key: 2, value: '审核中' },
}

export const SERVICE_TYPE_ENUM = {
    SERVICE_TYPE_FREE: { key: 0, value: '免费' },
    SERVICE_TYPE_PAY: { key: 1, value: '付费' },
    SERVICE_TYPE_FEATURED: { key: 2, value: '特色服务' },
}

export const CREDITS_OP_TYPE_ENUM = {
    CREDITS_OP_TYPE_DEFFAULT: { key: 0, value: '其他' },
    CREDITS_OP_TYPE_REDEEM: { key: 1, value: '积分兑换' },
    CREDITS_OP_TYPE_CANCEL: { key: 2, value: '取消' },
    CREDITS_OP_TYPE_ORDERED: { key: 3, value: '预约积分' },
    CREDITS_OP_TYPE_CONSUMPTION: { key: 4, value: '服务积分' },
    CREDITS_OP_TYPE_MANUAL: { key: 5, value: '发放积分' }
}

export const SERVICE_STATUS_ENUM = {
    SERVICE_STATUS_FREE: { key: 0, value: '空闲' },
    SERVICE_STATUS_ORDERED: { key: 1, value: '已预约' },
    SERVICE_STATUS_USING: { key: 2, value: '使用中' },
}

export const ORDER_EVENT_ENUM = {
    ORDER_EVENT_CHECKIN: 1,
    ORDER_EVENT_CANCELED: 2,
    ORDER_EVENT_CHECKOUT: 3,
}

export const ORDER_STATUS_ENUM = {
    ORDER_STATUS_ORDERED: { key: 0, value: '已预约' },
    ORDER_STATUS_USING: { key: 1, value: '已登记' },
    ORDER_STATUS_CANCELED: { key: 2, value: '已取消' },
    ORDER_STATUS_COMPLETED: { key: 3, value: '已完成' },
    ORDER_STATUS_INITIAL: { key: 4, value: '已完成' },
}

export const PAYMENT_TYPE_ENUM = {
    PAYMENT_TYPE_WX: { key: 0, value: '微信' },
    PAYMENT_TYPE_ALI: { key: 1, value: '支付宝' },
    PAYMENT_TYPE_CASH: { key: 2, value: '现金' },
    PAYMENT_TYPE_OTHER: { key: 3, value: '其他' },
}

export const PAYMENT_STATUS_ENUM = {
    PAYMENT_STATUS_FREE: { key: 0, value: '免费' },
    PAYMENT_STATUS_UNPAID: { key: 1, value: '未支付' },
    PAYMENT_STATUS_PAID: { key: 2, value: '已支付' }
}

export const TRANSACTION_TYPE_ENUM = {
    CONSUMPTION: { key: 1, value: '消费' },
    RECHARGE: { key: 2, value: '充值' },
    PROMOTION: { key: 3, value: '活动促销' },
    ADMINMODIFY: { key: 4, value: '管理员修改' },
}

export const CARD_TYPE_ENUM = {
    EXPERIENCE_CARD: { key: 1, value: '体验卡' },
    VIP_CARD: { key: 2, value: '贵宾卡' },
    VIP_FAMILY_CARD: { key: 3, value: '情亲卡' },
}